import { ContestActivities, LeaderBoardSvg, AboutSvg } from 'src/assets'
import { MdKeyboardArrowRight } from 'react-icons/md'

interface IcontestMenu {
  id: number
  title: string
  description: string
  ArrowRight: any
  Svg: any
  path: string
}

export const joinedContestNav: IcontestMenu[] = [
  {
    id: 1,
    title: 'About',
    description: 'See more about this contest',
    ArrowRight: MdKeyboardArrowRight,
    Svg: AboutSvg,
    path: '/joined-contest/about',
  },
  {
    id: 2,
    title: 'Activities',
    description: 'See what your participants are doing',
    ArrowRight: MdKeyboardArrowRight,
    Svg: ContestActivities,
    path: '/joined-contest/activity',
  },
  {
    id: 3,
    title: 'Leaderboard',
    description: 'Click to see the top savers',
    ArrowRight: MdKeyboardArrowRight,
    Svg: LeaderBoardSvg,
    path: '/joined-contest/leaderboard',
  },
]
